import React from 'react';
import { Container, Row, Col, Button, Card, Carousel } from 'react-bootstrap';
import { FaLaptopCode, FaMobileAlt, FaCloud, FaRobot, FaGraduationCap, FaLightbulb, FaUsers, FaChartLine } from 'react-icons/fa';
import './home.css';

const Home = () => {
    return (
        <div className="home-page">
            <div className="hero-section" style={{ background: 'url(/assets/site_img21.jpg) center center/cover', height: '500px', color: 'white', textAlign: 'center', padding: '150px 0' }}>
                <Container>
                    <h1>Innovative Software Solutions</h1>
                    <p className="lead">Transforming your ideas into powerful digital experiences</p>
                    <a className='btn btn-light'>
                        Get Started
                    </a>
                </Container>
            </div>

            <section className="about-section py-5">
                <Container>
                    <h2 className="text-center mb-5">CodeFlex</h2>
                    <Row>
                        <Col md={3} className="mb-4">
                            <Card className="about-card h-100">
                                <Card.Body className="text-center">
                                    <FaLightbulb className="about-icon" />
                                    <Card.Title>Our Mission</Card.Title>
                                    <Card.Text>
                                        Building innovative, scalable software solutions that empower businesses and individuals.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} className="mb-4">
                            <Card className="about-card h-100">
                                <Card.Body className="text-center">
                                    <FaUsers className="about-icon" />
                                    <Card.Title>Our Team</Card.Title>
                                    <Card.Text>
                                        Highly skilled professionals specializing in cutting-edge technologies.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} className="mb-4">
                            <Card className="about-card h-100">
                                <Card.Body className="text-center">
                                    <FaLaptopCode className="about-icon" />
                                    <Card.Title>Our Expertise</Card.Title>
                                    <Card.Text>
                                        Custom software, web/mobile apps, cloud solutions, AI/ML, and IoT.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} className="mb-4">
                            <Card className="about-card h-100">
                                <Card.Body className="text-center">
                                    <FaChartLine className="about-icon" />
                                    <Card.Title>Our Approach</Card.Title>
                                    <Card.Text>
                                        Tailored solutions to meet unique needs and drive growth.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="services-section py-5 bg-light">
                <Container>
                    <h2 className="text-center mb-5">Our Services</h2>
                    <Row>
                        <Col md={3} className="mb-4">
                            <Card className="service-card h-100">
                                <Card.Body className="text-center">
                                    <FaLaptopCode className="service-icon" />
                                    <Card.Title>Custom Software</Card.Title>
                                    <Card.Text>
                                        Tailored solutions designed specifically for your business requirements.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} className="mb-4">
                            <Card className="service-card h-100">
                                <Card.Body className="text-center">
                                    <FaMobileAlt className="service-icon" />
                                    <Card.Title>Mobile Apps</Card.Title>
                                    <Card.Text>
                                        iOS and Android applications with stunning UI/UX.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} className="mb-4">
                            <Card className="service-card h-100">
                                <Card.Body className="text-center">
                                    <FaCloud className="service-icon" />
                                    <Card.Title>Cloud Solutions</Card.Title>
                                    <Card.Text>
                                        Scalable cloud infrastructure and services.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} className="mb-4">
                            <Card className="service-card h-100">
                                <Card.Body className="text-center">
                                    <FaRobot className="service-icon" />
                                    <Card.Title>AI & ML</Card.Title>
                                    <Card.Text>
                                        Intelligent systems powered by artificial intelligence.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="careers-section py-5">
                <Container>
                    <Row className="align-items-center">
                        <h2>Careers at CodeFlex</h2>
                        <p>
                            Join our team of innovators and work on exciting projects with cutting-edge technologies.
                        </p>
                        <div className="internship-card p-4 mb-4">
                            <FaGraduationCap className="internship-icon" />
                            <h4>Internship Program</h4>
                            <p>
                                Gain real-world experience and mentorship from industry experts. Our internship program is designed to help you grow your skills and kickstart your career in tech.
                            </p>
                            <a className="btn btn-light">Apply Now</a>
                        </div>
                    </Row>
                </Container>
            </section>

            {/* Contact CTA */}
            <section className="contact-cta py-5 bg-primary text-white">
                <Container className="text-center">
                    <h2>Ready to Start Your Project?</h2>
                    <p className="lead mb-4">Let's build something amazing together</p>
                    <a className="btn btn-light" >
                        Contact Us
                    </a>
                </Container>
            </section>
        </div>
    );
};

export default Home;